import { render, staticRenderFns } from "./sales-order.vue?vue&type=template&id=e2098b60&scoped=true&"
import script from "./sales-order.vue?vue&type=script&lang=js&"
export * from "./sales-order.vue?vue&type=script&lang=js&"
import style0 from "./sales-order.vue?vue&type=style&index=0&id=e2098b60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2098b60",
  null
  
)

export default component.exports